module.exports = __webpack_public_path__ + "static/img/tedian.2ee886ad.png";